<h2 mat-dialog-title class="admin-confirm-dialog__title">{{ data.title }}</h2>
<mat-dialog-content class="admin-confirm-dialog__content">
  <p class="admin-confirm-dialog__body">{{ data.body }}</p>
  <p class="admin-confirm-dialog__consequence">{{ data.consequence }}</p>
  @if (errorMessage) {
    <p
      class="admin-confirm-dialog__error"
      role="alert"
      data-testid="admin-confirm-dialog-error"
    >
      {{ errorMessage }}
    </p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="admin-confirm-dialog__actions">
  <button
    mat-button
    type="button"
    cdkFocusInitial
    class="admin-confirm-dialog__cancel"
    [disabled]="submitting"
    (click)="onCancel()"
    data-testid="admin-confirm-dialog-cancel"
  >
    Cancel
  </button>
  <button
    mat-flat-button
    type="button"
    class="admin-confirm-dialog__confirm"
    [class.admin-confirm-dialog__confirm--destructive]="data.destructive"
    [disabled]="submitting"
    (click)="onConfirm()"
    data-testid="admin-confirm-dialog-confirm"
  >
    @if (submitting) {
      <mat-spinner
        class="admin-confirm-dialog__spinner"
        diameter="18"
        mode="indeterminate"
      ></mat-spinner>
    }
    {{ data.confirmLabel }}
  </button>
</mat-dialog-actions>
